export enum LOCAL_STORAGE {
  USER = 'user',
  ISLOGIN = 'islogin',
  TOKEN = 'token',
  PASSWORD = 'password',
}

export enum INPUT_GLOBAL_TYPES {
  Text = 'text',
  Password = 'password',
  Email = 'email',
  Number = 'number',
  Checkbox = 'checkbox',
  Radio = 'radio',
  File = 'file',
  Date = 'date',
  Month = 'month',
  Week = 'week',
  Time = 'time',
  DatetimeLocal = 'datetime-local',
  Url = 'url',
  Search = 'search',
  Tel = 'tel',
  Color = 'color',
  Range = 'range',
  Button = 'button',
  Reset = 'reset',
  Submit = 'submit',
  Hidden = 'hidden',
  Image = 'image',
}

export enum CODITION {
  NEW = 'Новый',
  USED = 'Б/У',
}

export enum LISTING_NAMES {
  IMG1 = 'img1',
  IMG2 = 'img2',
  IMG3 = 'img3',
  NAME = 'name',
  CATEGORY = 'category',
  CONDITION = 'condition',
  ADRESS = 'adress',
  CITY = 'city',
  DESCRIPTION = 'description',
  PRICE = 'price',
}

export enum MODAL_TYPES {
  LOG_IN = 'login',
  REGISTRATION = 'registration',
  DELETE = 'delete',
}

export interface UserInterface {
  id: number;
  name: string;
  avatar?: string | File | null;
  email?: string;
  password?: string;
  admin?: boolean | null;
}

export interface ListingDataInterface {
  id: number;
  img1: File | string | null;
  img2?: File | string | null;
  img3?: File | string | null;
  name: string;
  category: string;
  condition: string;
  adress?: string;
  city: string;
  description: string;
  price: number;
  owner: number;
  isOwner?: boolean;
  setIsOwner?: (owner: boolean) => void;
  isFavorite: boolean | null;
  ownerUsername: string;
  ownerEmail: string;
}

export const radioInputText = {
  valueNew: 'Новый',
  valueUsed: 'Б/У',
};

export const cities: string[] = [
  'Москва',
  'Санкт-Петербург',
  'Новосибирск',
  'Екатеринбург',
  'Нижний Новгород',
  'Казань',
];

export const category: string[] = [
  'Авто',
  'Книги',
  'Садоводство',
  'Хобби',
  'Технологии',
];

export const BASE_URL_API = process.env.REACT_APP_API_URL || '/api';